import { useTranslation } from "react-i18next";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
import Modal from "./ModalWithFooter";
import TutorModel from "../../api/models/TutorModel";
import TelawahModel from "../../api/models/TelawahModel";
import SponsorshipModel from "../../api/models/SponsorshipModel";
import { useNavigate } from "react-router-dom";
import { StarIcon } from "@heroicons/react/outline";
import { useMemo } from "react";

type Props = {
  tutor: TutorModel;
  onClose?: () => void;
  cancel: boolean;
  setIsOpen: () => void;
  open: boolean;
};

export default function TutorInfoModal({
  tutor,
  onClose,
  open,
  cancel,
  setIsOpen,
}: Props) {
  const LocalBasePath = "page.supervisor.tutor";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const navigate = useNavigate();

  const onShowDetails = () => {
    !!setIsOpen && setIsOpen();
    navigate(`/supervisor/dashboard/tutors/${tutor.id}/insights`);
  };
  const rateElement = useMemo(() => {
    if (!!tutor?.statistics?.overall_rating?.[1]) {
      const rateValue = Number(tutor?.statistics?.overall_rating?.[1]).toFixed(
        0
      );
      return (
        <>
          {Array.apply(null, Array(+rateValue)).map((rating, index) => (
            <StarIcon
              key={index}
              className="text-yellow-400 h-5 w-5 flex-shrink-0"
              ria-hidden="true"
            />
          ))}
          {Array.apply(null, Array(4 - +rateValue)).map((rating, index) => (
            <StarIcon
              key={index}
              className="text-gray-200 h-5 w-5 flex-shrink-0"
              aria-hidden="true"
            />
          ))}
        </>
      );
    } else {
      return (
        <>
          {Array.apply(null, Array(4)).map((rating, index) => (
            <StarIcon
              key={index}
              className="text-gray-200 h-5 w-5 flex-shrink-0"
              aria-hidden="true"
            />
          ))}
        </>
      );
    }
  }, [tutor]);
  return (
    <Modal className="max-w-[512px]" open={open} setOpen={onClose}>
      <Modal.Body
        className={"border-b border-gray-200 pb-4"}
        setOpen={onClose}
        title={t("tutorInfo")}
      >
        <div className="bg-white h-full   ">
          <div className="h-full overflow-y-auto overflow-x-hidden  md:mx-0">
            <div className="w-full flex flex-col">
              <div className="flex flex-col items-start gap-3  mb-6">
                <UserProfilePictureAvatar
                  profilePictureUrl={tutor?.profile_picture_url}
                  className="w-14 h-14 flex-shrink-0"
                  alt={tutor?.firstName}
                />
                <div className="flex flex-col gap-1">
                  <p className="text-gray-600 text-xl leading-6 font-medium">
                    {tutor?.fullNameWithoutMiddle}
                  </p>
                  <p className="text-sm leading-5 text-gray-400 ">
                    {tutor?.account?.email}
                  </p>
                </div>
                <div>
                  <span
                    className={
                      "inline-flex items-center h-fit rounded-full py-1 px-2 text-xs font-normal whitespace-nowrap bg-green-50 text-green-500"
                    }
                  >
                    {t("tutor")}
                  </span>
                </div>
              </div>

              <div className="w-full  border-b mb-2  border-gray-200 flex flex-col items-start  py-4">
                <div>
                  <p className="text-xs  text-gray-500">{t("reading")}</p>
                </div>
                <div>
                  {!!tutor?.telawahs &&
                    tutor.telawahs.map((telawah: TelawahModel) => (
                      <div>
                        <span className="flex justify-start gap-1">
                          <span>
                            <h1 className="text-base  text-gray-700">
                              {telawah?.name}
                            </h1>
                          </span>
                        </span>
                      </div>
                    ))}
                </div>
              </div>
              <div className="w-full  border-b mb-2  border-gray-200 flex flex-col items-start  py-4">
                <div>
                  <p className="text-xs  text-gray-500">{t("carePackage")}</p>
                </div>
                <div>
                  {!!tutor?.sponsorship &&
                    tutor.sponsorship.map((sponsorship: SponsorshipModel) => (
                      <div>
                        <span className="flex justify-start gap-1">
                          <span>
                            <h1 className="text-base  text-gray-700">
                              {sponsorship?.sponsor?.name}
                            </h1>
                          </span>
                        </span>
                      </div>
                    ))}
                </div>
              </div>
              <div className="w-full gap-2  border-b mb-2  border-gray-200 flex flex-col items-start  py-4">
                <div>
                  <p className="text-xs  text-gray-500">{t("studentRate")}</p>
                </div>

                <div className="flex items-center">{rateElement}</div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-full flex  justify-end">
          <button
            type="button"
            className=" inline-flex items-center justify-center px-4 py-2 border text-sm font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 bg-brandblue-600 focus:ring-offset-2 border-brandblue-600  text-white hover:text-brandblue-600  hover:bg-white disabled:opacity-80 disabled:hover:bg-brandblue-600 focus:ring-brandblue-500"
            onClick={onShowDetails}
          >
            <div className="flex gap-2">{t("showDetails")}</div>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
